import "core-js/stable";
import "regenerator-runtime/runtime";
import moment from "moment-timezone";
import "moment/locale/fr";

import { loadSessionOnceFromServer } from "./feature";
import reportWebVitals from "./reportWebVitals";
import * as api from "./utils/api";
import "./utils/i18n";
import "./utils/react-intl-polyfill";

moment.locale("fr");
moment.tz.setDefault("Europe/Paris");

// Get the session from the API, update the sessionStorage & re-load the ReactApp
api
  .getSession()
  .then((response) => {
    if (response.status >= 400) {
      throw new Error("getSession: Bad response from server");
    }

    return response.data;
  })
  .then((updatedSession) => {
    loadSessionOnceFromServer(updatedSession);
  });

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
